angular.module('TetherApp').directive('tetherDiv', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherDiv.html'
    }
});
